import { useMemo } from 'react';
import { VehicleBasedDemandState } from 'types/demand.type';

export function usePriceWidgetPeopleLimits(
  state: VehicleBasedDemandState,
  diningCapacity: number,
  fullCapacity: number
) {
  const MAX_PEOPLE = useMemo(
    () => (state.selectedMeal ? diningCapacity : fullCapacity),
    [state.selectedMeal, diningCapacity, fullCapacity]
  );

  const MIN_PEOPLE = useMemo(() => 1, []);

  return {
    MAX_PEOPLE,
    MIN_PEOPLE,
  };
}
